export default __webpack_public_path__ + "static/media/transak.53dab15f.svg";